import React from "react";
import Image from "react-image";
import {
  Col,
  Row
} from "reactstrap";
import { connect } from "react-redux";

export const LogoFooterComponent = ({ theme, dispatch, ...props }) => {
  const background = theme["logo_footer"];
  return background && background !== '' ? (<Row className="justify-content-center">
          <Col md="4" style={{textAlign : 'center'}}>
              <Image src={background} {...props} />
          </Col>
  </Row> ): null;
};

const mapStateToProps = state => ({
  theme: { ...state.theme }
});

export const LogoFooterComponentConnected = connect(mapStateToProps)(LogoFooterComponent);
